import { Modal, Button, Typography, Input } from 'antd';
import '@src/styles/components/customModal.scss';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import CustomText, { useText } from '@src/components/Text';

const { Text } = Typography;

const CustomDCCEditModal = ({
  title,
  isModalVisible,
  setIsModalVisible,
  clickOk,
  editItem = null,
  isCostCenter = false,
}) => {
  const departmentNameText = useText('departmentName');
  const costCenterName = useText('costCenterName');
  const enterDepartmentName = useText('enterDepartmentName');
  const enterCostCenterName = useText('enterCostCenterName');
  const addText = useText('add');
  const updateText = useText('updateBtn');

  const [departmentName, setDepartmentName] = useState('');

  useEffect(() => {
    if (editItem?.costCenterLabel || editItem?.label) {
      setDepartmentName(editItem.costCenterLabel ?? editItem.label);
    }
  }, [editItem]);

  const handleOk = () => {
    clickOk(departmentName);
    setDepartmentName('');
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setDepartmentName('');
  };

  return (
    <Modal
      title={<Text className="cost-center-modal-title">{title}</Text>}
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={null}
      centered
      bodyStyle={{
        backgroundColor: '#f7f9fc',
        padding: '20px',
      }}
      style={{
        borderRadius: '10px',
      }}
    >
      <div style={{ marginBottom: '20px' }}>
        <Text
          style={{
            fontWeight: 'bold',
            display: 'block',
            marginBottom: '8px',
          }}
        >
          {isCostCenter ? costCenterName : departmentNameText}
        </Text>

        <Input
          placeholder={
            isCostCenter ? enterCostCenterName : enterDepartmentName
          }
          value={departmentName}
          className="cost-center-modal-input"
          onChange={(e) => setDepartmentName(e.target.value)}
        />
      </div>

      <div
        style={{
          display: 'flex',
          gap: 20,
          alignItems: 'center',
          marginTop: '20px',
        }}
      >
        <Button
          type="primary"
          style={{
            color: '#efefef',
            borderRadius: 6,
            width: 120,
            height: 38,
            fontWeight: 'bold',
          }}
          onClick={handleOk}
        >
          {editItem ? updateText : addText}
        </Button>

        <Typography.Link
          style={{
            color: '#0f172a',
            fontWeight: '600',
            fontSize: 16,
            textDecoration: 'underline',
          }}
          onClick={handleCancel}
        >
          <CustomText t="giveUp" />
        </Typography.Link>
      </div>
    </Modal>
  );
};

CustomDCCEditModal.propTypes = {
  title: PropTypes.string,
  isModalVisible: PropTypes.bool,
  setIsModalVisible: PropTypes.func,
  clickOk: PropTypes.func,
  editItem: PropTypes.any,
  isCostCenter: PropTypes.bool,
};

export default CustomDCCEditModal;